export default function GridIcon(
  props: Pick<
    React.SVGProps<SVGSVGElement>,
    "className" | "fill" | "fillOpacity"
  >,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.08333 2C3.34695 2 2.75 2.59695 2.75 3.33333V6C2.75 6.73638 3.34695 7.33333 4.08333 7.33333H6.75C7.48638 7.33333 8.08333 6.73638 8.08333 6V3.33333C8.08333 2.59695 7.48638 2 6.75 2H4.08333ZM4.08333 3.33333H6.75V6H4.08333V3.33333ZM4.08333 8.66667C3.34695 8.66667 2.75 9.26362 2.75 10V12.6667C2.75 13.403 3.34695 14 4.08333 14H6.75C7.48638 14 8.08333 13.403 8.08333 12.6667V10C8.08333 9.26362 7.48638 8.66667 6.75 8.66667H4.08333ZM4.08333 10H6.75V12.6667H4.08333V10ZM9.41667 3.33333C9.41667 2.59695 10.0136 2 10.75 2H13.4167C14.153 2 14.75 2.59695 14.75 3.33333V6C14.75 6.73638 14.153 7.33333 13.4167 7.33333H10.75C10.0136 7.33333 9.41667 6.73638 9.41667 6V3.33333ZM13.4167 3.33333H10.75V6H13.4167V3.33333ZM10.75 8.66667C10.0136 8.66667 9.41667 9.26362 9.41667 10V12.6667C9.41667 13.403 10.0136 14 10.75 14H13.4167C14.153 14 14.75 13.403 14.75 12.6667V10C14.75 9.26362 14.153 8.66667 13.4167 8.66667H10.75ZM10.75 10H13.4167V12.6667H10.75V10Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
